import { EntityModificationPack, EntityModification } from '@wizeoo/akm-message-lib';

/** un pack de modif encapsulé pour rendu */
export class EmPackVO {
  /**
   * Le VO source provenant du back
   */
  private _source: EntityModificationPack;

  constructor(pSource?: EntityModificationPack) {
    this._source = pSource ? pSource : new EntityModificationPack();
  }

  /** accesseur sur le 1er EM */
  public get firstEM(): EntityModification {
    return this._source.ems[0];
  }

  /** la classe de l'objet manipulé (premier objet) */
  public get class(): number {
    return this.firstEM.entityClass;
  }
  /** le user à l'origine de la modif */
  public get login(): string {
    return this.firstEM.login;
  }

  public set domain(domain: string) {
    this._source.domain = domain;
  }

  public get domain(): string {
    return this._source.domain;
  }

  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }

  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }
}
